import { ApolloProvider } from '@apollo/client'
import { Layout } from 'antd'
import type { AppProps } from 'next/app'
import { useRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

import { ErrorPage } from '../components/ui/ErrorPage'
import { SuspenseWithLoading } from '../components/ui/SuspenseWithLoading'
import { useApolloClient } from '../services/apollo_client'
import { Posthog } from '../services/posthog'

import { DefaultHead } from './base/DefaultHead'

const NotAuthenticatedApolloProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const client = useApolloClient({ token: null, tenantId: null })

  if (client === undefined) {
    return <></>
  }

  return (
    <ApolloProvider client={client}>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <SuspenseWithLoading>{children}</SuspenseWithLoading>
      </ErrorBoundary>
    </ApolloProvider>
  )
}

const Body = (props: AppProps) => {
  const { Component, router } = props
  Posthog.trackAccess(router.pathname, {})
  const nodeRef = useRef<HTMLDivElement>(null)
  return (
    <>
      <DefaultHead />
      <Layout className="h-full ">
        <SwitchTransition>
          <CSSTransition key={router.asPath} timeout={200} classNames="page-transition" nodeRef={nodeRef}>
            <div ref={nodeRef}>
              <Component />
            </div>
          </CSSTransition>
        </SwitchTransition>
      </Layout>
    </>
  )
}

export const NoMemberLayout = (props: AppProps) => {
  return (
    <NotAuthenticatedApolloProvider>
      <Body {...props} />
    </NotAuthenticatedApolloProvider>
  )
}
